"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Modal = require("@ccw-pwa-ui/Modal");
var _react = _interopRequireDefault(require("react"));
require("../styles/SystemAccessoryTile.css");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
const SystemAccessoryComponent = _ref => {
  var _system$waterDest;
  let {
    system,
    systemImage,
    systemName,
    systemPartNumber,
    installedText,
    installedDate,
    questionIcon,
    aboutText,
    waterDestinationItem,
    handleAboutText,
    aboutTextModalData,
    aboutTextModal,
    arrowImageRight,
    isArrowImageVisible,
    onClickSystemArrow,
    editTextRight
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "system-Infomation-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-left-right-content-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-left-content-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: systemImage,
    className: "system-image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "right-content-container"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-name"
  }, /*#__PURE__*/_react.default.createElement("span", null, systemName))), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-part-number"
  }, /*#__PURE__*/_react.default.createElement("span", null, systemPartNumber))), isArrowImageVisible ? /*#__PURE__*/_react.default.createElement("div", {
    className: "arrow-content-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClickSystemArrow,
    "data-testid": "arrowSystemClick",
    className: "outer-div-edit-text"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "arrow",
    src: arrowImageRight,
    className: "edit-system-icon"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-system-text"
  }, editTextRight))) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-wrapper-accessory"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-accessory"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-content-style"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: installedText
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 13,
      color: '#333333',
      fontWeight: 600,
      marginTop: 3
    },
    variant: "header-text",
    headerText: installedDate
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "middle-text-content-style"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: "Water Dest."
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "water-dest-wrapper"
  }, system === null || system === void 0 ? void 0 : (_system$waterDest = system.waterDest) === null || _system$waterDest === void 0 ? void 0 : _system$waterDest.map(system => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "water-dest-cwrapper",
      key: system.name
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "water-dest-content"
    }, /*#__PURE__*/_react.default.createElement("p", null, system.name)), /*#__PURE__*/_react.default.createElement("img", {
      src: waterDestinationItem[system.name],
      className: "water-dest-image"
    }));
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "lower-content",
    "data-testid": "aboutText-div",
    onClick: handleAboutText
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: questionIcon,
    className: "question-image"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "about-text"
  }, aboutText)), aboutTextModal && /*#__PURE__*/_react.default.createElement("div", {
    className: "about-thesystem-modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.displayModal,
    modalHeaderText: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.modalHeaderText,
    modalHeaderTextStyle: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.modalHeaderTextStyle,
    modalDetailText: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.modalDetailText,
    modalHeaderIcon: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.modalHeaderIcon,
    displayCrossIcon: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.displayCrossIcon,
    variant: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.variant,
    positiveActionButtonTitle: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.positiveActionButtonTitle,
    positiveAction: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.positiveAction,
    negativeButtonActionTitle: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.negativeButtonActionTitle,
    crossIconAction: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.crossIconAction,
    negativeAvtion: aboutTextModalData === null || aboutTextModalData === void 0 ? void 0 : aboutTextModalData.negativeAvtion
  })));
};
var _default = exports.default = SystemAccessoryComponent;